import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  overflow-x: hidden;
  margin-right: 150px;
  @media (min-width: 762px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    ${props => props.disableScroll && 'overflow-y: hidden;'}
  }

  @media (max-width: 770px) {
    overflow-y: hidden;
  }
`;

export const Box = styled.div`
  display: flex;
  justify-content: flex-start;
  max-width: 620px;
  margin: 1rem auto 0 auto;
  flex-direction: column;
  padding: 20px 20px 0px 20px;

  @media (min-width: 770px) and (min-height: 400px) {
    margin: 25% 0 0 0;
  }

  @media (min-width: 770px) and (min-height: 580px) {
    margin: 10% 0 0 0;
  }

  @media (min-width: 770px) and (min-height: 700px) {
    margin: -3% 0 0 0;
  }

  @media (max-width: 770px) {
    justify-content: space-between;
    height: 100vh;
    overflow-y: ${props => (props.disabledScroll ? 'hidden' : 'scroll')};
    margin: 0 auto 0 auto;
  }
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  height: 55px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  .close-icon {
    color: #ffffff;
    cursor: pointer;
    font-size: 30px;
  }
  @media (max-width: 770px) {
    margin-bottom: 20px;
  }
`;

export const Left = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  @media (min-width: 770px) {
    margin: 10% 0 5% 0;
  }
`;

export const Title = styled.span`
  font-size: 23px;
  color: #ffffff;
  margin-left: 10px;

  @media (max-width: 770px) {
    font-size: 20px;
  }
`;

export const Icon = styled.span`
  font-size: 35px;
  color: #ffffff;
`;

export const CloseIcon = styled.span`
  font-size: 25px;
  margin-top: -50px;
  margin-right: -11px;
  color: #ffffff;
  cursor: pointer;
`;

export const Content = styled.div`
  width: 100%;
  background-color: #ffffff;
  padding: 20px;
  border-top-left-radius: 22px;
  border-top-right-radius: 22px;

  @media (min-width: 762px) {
    width: auto;
    height: auto;
    padding: 30px 50px;
    border-radius: 22px;
    margin: 25px 0 15px 0;
  }
`;

export const ImportantHeader = styled.div`
  width: 100%;
  align-items: center;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
  span {
    font-size: 20px;
    color: #487cf5;
    font-weight: bold;
    margin-left: 25px;
  }
`;

export const TextConfirm = styled.span`
  color: #707070;
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 30px;
`;

export const Item = styled.div`
  margin-top: 10px;
  display: flex;
  align-items: flex-start;

  img {
    margin-right: 10px;
    width: 15px;
    margin-top: 4px;
  }

  span {
    color: #707070;
    font-size: 14px;
  }

  button {
    text-decoration: underline;
    color: #4a7af5;
    font-size: 13px;
    border: 0;
    outline: none;
    background-color: transparent;
  }

  @media (min-width: 762px) {
    width: 45%;
  }
`;

export const OpenAnswer = styled.span`
  text-decoration: underline !important;
  color: #4a7af5 !important;
  font-size: 13px;
  cursor: pointer;
`;

export const InfoContainer = styled.div`
  width: 100%;
  padding: 10px 15px;
  box-shadow: 0px 1px 2px #00000034;
  border: 1px solid #000fff;
  border-radius: 8px;
  margin-top: 20px;
  display: flex;

  i {
    color: #000fff;
    margin-right: 10px;
  }

  span {
    color: #707070;
    font-size: 13px;
  }
`;

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Button = styled.button`
  width: 100%;
  padding: 7px 20px;
  background: #4a7af5;
  box-shadow: 0px 3px 6px #00000066;
  border: 0;
  outline: 0;
  border-radius: 10px;
  margin-top: 20px;
  color: #ffffff;
  @media (min-width: 762px) {
    width: 264px;
    margin-top: 50px;
  }
`;

export const ItemContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  flex-direction: column;
  @media (min-width: 762px) {
    flex-direction: row;
  }
`;

export const LoadingIcon = styled.i`
  font-size: 18px;
`;

export const ModalHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-bottom: -20px;

  i {
    cursor: pointer;
    opacity: 0.5;
  }
`;
